function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawScooter = function UndrawScooter(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1117.97 735.28",
    style: style
  }, props), React.createElement("path", {
    d: "M1027.85 197.92c50.92-1.94 91.26-44.92 90.09-95.86a93.73 93.73 0 0 0-93.7-91.52h-1.56a93.86 93.86 0 0 0-90.12 2A93.29 93.29 0 0 0 883.25.03c-50.17 1.28-90.75 42.53-91.26 92.72a93.32 93.32 0 0 0 19 57.61 93.31 93.31 0 0 0-13 47.07c-.29 50.5 40.11 92.57 90.58 94.22a93.56 93.56 0 0 0 35.83-5.81c18.44 23.18 39.53 51.88 35.35 62.13-5.23 12.82-2.12 142.94-.64 195.15a23.79 23.79 0 0 0 .24 2.69c-34.56 1.89-59.57 7.37-59.57 13.84 0 8 38.5 14.54 86 14.54s86-6.51 86-14.54c0-3-5.53-5.86-15-8.2a42.26 42.26 0 0 0 7-5.24c1.91-1.77 3.71-3.87 4.26-6.42s-.54-5.61-3-6.54c-2.73-1.05-5.65.85-7.86 2.76s-4.75 4.09-7.65 3.69a11.65 11.65 0 0 0 3.6-10.9 4.56 4.56 0 0 0-1-2.21c-1.52-1.62-4.27-.93-6.08.35-5.78 4.06-7.39 11.91-7.42 19-.58-2.55-.09-5.2-.11-7.81s-.73-5.51-2.93-6.92a8.92 8.92 0 0 0-4.48-1c-2.59-.09-5.48.17-7.26 2.07-2.2 2.35-1.63 6.31.29 8.91s4.83 4.22 7.51 6l.41.27c-8.71-.94-18.48-1.63-29-2a20.88 20.88 0 0 0 .19-2.51c.92-50.57 3.44-172.93 6.75-187.47 4.18-18.38 0-130.29 0-130.29s-.44-12.43.16-28.18a95.61 95.61 0 0 0 17.69.91zm-78.15 73.72a91.89 91.89 0 0 0 7.42-6.51l2.68 17.71z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M884.53 376.88a34.37 34.37 0 0 0-1.32-68.71h-.57a34.43 34.43 0 0 0-33 .73 34.37 34.37 0 0 0-44.66 50.54 34.38 34.38 0 0 0 41.59 49.69c6.77 8.5 14.5 19 13 22.78-1.92 4.71-.78 52.43-.24 71.57a7.92 7.92 0 0 0 .09 1c-12.68.69-21.85 2.7-21.85 5.07 0 3 14.12 5.34 31.54 5.34s31.54-2.39 31.54-5.34c0-1.11-2-2.15-5.48-3a16.53 16.53 0 0 0 2.57-1.92 4.73 4.73 0 0 0 1.56-2.36 2.08 2.08 0 0 0-1.09-2.4c-1-.38-2.07.31-2.88 1s-1.74 1.51-2.81 1.36a4.24 4.24 0 0 0 1.32-4 1.7 1.7 0 0 0-.36-.81c-.56-.59-1.57-.34-2.23.13-2.12 1.49-2.71 4.37-2.72 7a12.51 12.51 0 0 1 0-2.87 3 3 0 0 0-1.08-2.54 3.28 3.28 0 0 0-1.64-.38 3.36 3.36 0 0 0-2.66.76 2.65 2.65 0 0 0 .1 3.27 10.42 10.42 0 0 0 2.76 2.2l.15.1c-3.2-.34-6.78-.6-10.62-.73 0-.3.06-.61.07-.92.33-18.54 1.26-63.42 2.47-68.75 1.54-6.74 0-47.78 0-47.78s-.16-4.56.06-10.34a34.11 34.11 0 0 0 6.39.31zm-28.66 27.05a34.43 34.43 0 0 0 2.72-2.39l1 6.49z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 588.96,
    cy: 715.84,
    rx: 156.99,
    ry: 19.44,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("g", {
    opacity: 0.5
  }, React.createElement("path", {
    d: "M270.34 246.73c-12 16.86-21.23 65.93-23.8 80.72l-21.48-.44c1.11-12.7 26.1-64.38 33.05-78.56 3.87-.61 7.99-1.2 12.23-1.72z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: "#dce0ed",
    d: "M528.917 235.969l9.518-.18.253 13.408-9.519.18z"
  }), React.createElement("path", {
    d: "M538.44 235.77l.08 4.36a7.09 7.09 0 0 1-2.06.32l-7.45.08-.09-4.58z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M524.26 201.88l9-.17a10.77 10.77 0 0 1 10.11 6.54c2.75 6.42 5.18 16.68-.48 27.06a7.42 7.42 0 0 1-6.44 3.87l-11.47.12z",
    fill: "#dce0ed"
  }), React.createElement("ellipse", {
    cx: 565.64,
    cy: 302.95,
    rx: 9.62,
    ry: 18.72,
    transform: "translate(-46.64 -71.62)",
    fill: "#f0f0f4"
  }), React.createElement("path", {
    fill: "#dce0ed",
    d: "M444.86 237.22l9.52-.191.234 11.74-9.52.19z"
  }), React.createElement("path", {
    d: "M453.92 237.52l.07 3.73a6.77 6.77 0 0 1-2.06.32l-7.45.08-.07-3.95z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M439.74 203.64l9-.17a10.79 10.79 0 0 1 10.11 6.54c2.76 6.43 5.18 16.69-.48 27.07a7.43 7.43 0 0 1-6.44 3.87l-11.47.12z",
    fill: "#dce0ed"
  }), React.createElement("ellipse", {
    cx: 481.12,
    cy: 304.71,
    rx: 9.62,
    ry: 18.72,
    transform: "rotate(-1.08 -3907.667 2439.768)",
    fill: "#f0f0f4"
  }), React.createElement("path", {
    d: "M442.27 210.43s-3.54.63-1.6 5.28a32.47 32.47 0 0 1 2.26 7.06s3.59 1.78 3.33-4.32-3.99-8.02-3.99-8.02z",
    fill: "#dce0ed"
  }), React.createElement("ellipse", {
    cx: 127.77,
    cy: 566.99,
    rx: 56.15,
    ry: 61.54,
    transform: "rotate(-1.08 -4261.368 2702.769)",
    fill: "#636780"
  }), React.createElement("path", {
    d: "M106.69 426.54c-29.34 2.53-52.1 29.71-51.48 62.4.49 26.36 16 48.55 37.45 56.92 29.34-2.53 52.11-29.71 51.49-62.4-.5-26.36-16.04-48.55-37.46-56.92z",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 564.59,
    cy: 424.22,
    rx: 45.57,
    ry: 59.42,
    transform: "rotate(-1.08 -3823.912 2559.93)",
    fill: "#636780"
  }), React.createElement("path", {
    d: "M509.76 285.17c-18.76 7.6-32.12 30.64-31.61 57.63.54 28.84 16.75 52.57 37.75 57.58 18.76-7.6 32.13-30.64 31.62-57.62-.54-28.84-16.75-52.58-37.76-57.59z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M352.18 332.41l.43-21.59s-4.4-9.22-8.64-10-14-1.11-14-1.11-7 31.12-1.78 40.33 23.99-7.63 23.99-7.63z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M352.18 332.41l.43-21.59s-4.4-9.22-8.64-10-14-1.11-14-1.11-7 31.12-1.78 40.33 23.99-7.63 23.99-7.63z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M274.11 331.55s-3.18-29.85 13.24-30.7c2.12-.11 4.23-.2 6.33-.44 11.37-1.32 42.39-4.31 38.8 2.86 0 0-6.9 26.15-1.71 32.61zM508.06 382.64l22 .22s3-40.67 4.25-43.86 1.55-18.43-2.61-20.57-18-4.58-18-4.58l-9.71 23.34-.4 20.95z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M508.06 382.64l22 .22s3-40.67 4.25-43.86 1.55-18.43-2.61-20.57-18-4.58-18-4.58l-9.71 23.34-.4 20.95z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M453.5 316.21l-.18-4.51a2.61 2.61 0 0 1 2.67-2.72c10.93.26 50.72 1.41 57.75 4.83 0 0-6.54 56.75 2.11 70.07l-2 45.41-97.51-5.45z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M444.54 244.87c2.7-.32 5.91-.67 9.5-1l.1 5.41-9.51.18zM538.68 248.49v.68l-9.51.18-.08-4.11a40.25 40.25 0 0 1 9.59 3.25z",
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#dce0ed",
    d: "M588.96 382.5l-14.37.49-30.73-53.43-5.13-8.93 3.37-22.9 3.03 5.47 43.83 79.3zM457.68 318.57l-5.75 8.99-18.15-23.59-8.31-10.81 4.74-6.64 3.81 4.44 23.66 27.61z"
  }), React.createElement("path", {
    d: "M433.98 290.96c0 .46.07.93.11 1.4l-.35 11.61-8.31-10.81 4.75-6.65zM545.13 303.2l-1.27 26.36-5.13-8.93 3.37-22.9 3.03 5.47z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M417.5 308.12s-8.1-52.9 17.59-61.32a5.9 5.9 0 0 1 1-.23c5.94-.83 61.27-8.27 90.2-1.21 0 0 19.72 2.59 19.71 13.16l-6.22 129.35-14.17.27 3-85.51s6.06-37.34-5.19-39.66-62.29-5.59-80.17-.18c0 0-13.16-2.71-10.44 29.6l-.52 17.35z",
    fill: "#dce0ed"
  }), React.createElement("path", {
    d: "M460.98 323.05a8.19 8.19 0 0 0-3.47-7.23c-4-2.94-16.35-9.21-16.35-9.21l-4 .4-11.34 29.72 2 62.62 21.91 26.08z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M460.98 323.05a8.19 8.19 0 0 0-3.47-7.23c-4-2.94-16.35-9.21-16.35-9.21l-4 .4-11.34 29.72 2 62.62 21.91 26.08z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M376.75 390.32l-.77-64.29s-2.38-24.91 12.52-25.61c0 0 35.16-.41 50.53 4.26a3.41 3.41 0 0 1 2 4.89c-2.94 5.35-7.8 19.46-9.6 55.45l.73 38.53z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M451.69 429.99l-63.99-.28h-.07l-31.45-.14 2.86-42.09 17.45.31 55.74 11.32 17.47 26.32 1.99 4.56z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M451.69 429.99l-63.99-.28h-.07l-31.45-.14 2.86-42.09 17.45.31 55.74 11.32 17.47 26.32 1.99 4.56z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M451.69 429.99l-63.99-.28-1.59-28.15 46.12-2.45 17.47 26.32 1.99 4.56z"
  }), React.createElement("path", {
    d: "M387.63 429.71l-31.45-.14 2.85-42.09s10.13 15.51 27.08 14.08z",
    fill: "#fff",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M613.89 459.45c-1 12.07-9.64 10.33-9.64 10.33l-1.6-.11-15.87-1.15.28-18.72a69 69 0 0 1 16.09.66c5.97 1.12 11.2 3.62 10.74 8.99z",
    fill: "#dce0ed"
  }), React.createElement("path", {
    d: "M613.89 459.45c-1 12.07-9.64 10.33-9.64 10.33l-1.6-.11a16.22 16.22 0 0 1-2.7-9c-.08-4.19 1.19-7.93 3.2-10.2 5.97 1.11 11.2 3.61 10.74 8.98z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M365.85 306.13c-14.48.27-25.92 16.35-25.55 35.91s12.41 35.2 26.89 34.92 25.92-16.35 25.55-35.91-12.41-35.19-26.89-34.92zm-2.5 63.5c-11 .21-20.2-11.12-20.47-25.31s8.46-25.86 19.5-26.07 20.2 11.13 20.47 25.32-8.47 25.85-19.5 26.07z",
    fill: "#636780"
  }), React.createElement("path", {
    fill: "#636780",
    d: "M368 352.41l12.49 11.82 4.24-10.86-17.96-10.03 1.23 9.07z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M383.82 232.79l10.71 1.1 4.04 4.63-5.49 27.13-11.94 43.78-7.8 30.05-5.55 18.26-3.3 24.09-3.44 16.58L350 409.89l-23.4-26.59-3.93-8.94-9.35-18.22 23.06-11.32 25.48-2.74 11.43-31 9.08-35.84 1.45-42.45z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M170.27 365.67l-11.74 117.39 175.57-10.71-21.39-57.13-34.24-21.35 77.41-.19-.19-32.15-31.42-6.17-63.1-3.89-47.4-1.22-44.97 15.65"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M170.27 365.67l-11.74 117.39 175.57-10.71-21.39-57.13-34.24-21.35 77.41-.19-.19-32.15-31.42-6.17-63.1-3.89-47.4-1.22-44.97 15.65"
  }), React.createElement("path", {
    d: "M412.52 477.87c.55 29.11-8.62 55.79-35.51 53.39-33.86-.08-36.95-22.9-37.5-52s15.38-51.08 35.55-51.46 36.92 20.96 37.46 50.07z",
    fill: "#636780"
  }), React.createElement("path", {
    d: "M412.73 477.91c-.42-22.53-10.56-40.42-24.47-47.17-17.64 3.7-30.86 24.31-30.36 50.87.45 23.85 2.62 43.48 22 49.84 24.83.42 33.36-25.42 32.83-53.54z",
    opacity: 0.1
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M446.15 431.54l-10.1 12.01 18.52-3.54 13.64-13.02 11.92-25 17.25-11.03 42.89 5.01 39.63.75 14.37-13.26-16.35-1.91-16.52-.06-41.49-.16-49.38-.38-9.62 27.22-7.34 18.72-7.42 4.65z"
  }), React.createElement("path", {
    d: "M589.05 477.05c-.82 1.28-28.44 6-28.44 6l-76.27 15.4-131.48 4.38-15.68-12.78-8.08 1.6-.33.06-107.92 21.27-1.76-.22-29.6-3.65-154.51-19.06 1.25-22.41.75-13.23 1.6-27.46 1.4-7.22 13.71-1.51 6.4-.71 99.87-11.07 13.02-1.45 7.32-.81 71.29-11.07 104.28.57-.18-32.15 38.83-127.64c9.12 1.3 9 7.44 9 7.44l-32.81 120.12 1 73.38c73.13 6 75.19-10 86.84-4.81l13.11-44.88 122.64-1.68c4.94 5.83-5.25 93.59-5.25 93.59z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M283.54 416.19l40.48 82.79 13.19 3.97 2.92-13.58-15.47-46.03-15.52-26.57-25.6-.58z"
  }), React.createElement("path", {
    opacity: 0.15,
    d: "M283.54 416.19l40.48 82.79 13.19 3.97 2.92-13.58-15.47-46.03-15.52-26.57-25.6-.58z"
  }), React.createElement("ellipse", {
    cx: 300.97,
    cy: 591,
    rx: 70.47,
    ry: 79.94,
    transform: "rotate(-1.08 -4088.104 2726.685)",
    fill: "#636780"
  }), React.createElement("path", {
    d: "M283.67 433.23c-36.82 3.27-65.37 38.54-64.57 81 .64 34.23 20.17 63.07 47.06 73.95 36.82-3.26 65.37-38.54 64.57-81-.65-34.22-20.17-63.07-47.06-73.95z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M68.45 372.45l-3.18 16.51-9.72 50.57-46-3.57s-2.91-8.4 4.22-11.71c0 0 1.82-28.67 10.13-37.85a8.61 8.61 0 0 1 3.28-2.38z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M65.27 388.96l-9.72 50.57-46-3.57s-2.91-8.4 4.22-11.71c0 0 1.82-28.67 10.13-37.85z",
    fill: "#fff",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M171.98 374.94c6.1 9.82-6.54 101.65-6.54 101.65l-113-16.48 2.5-80.21c1.96-14.42 10.38-16.26 10.38-16.26 39.37-20.85 130.66-26.81 130.66-26.81 83.37 1.6 159.74 24.7 159.74 24.7-95.03-12.8-183.74 13.41-183.74 13.41z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M165.39 476.64l-113-16.48 2.5-80.21c2.01-14.47 10.43-16.31 10.43-16.31s82.1-9.38 106.61 11.31c6.1 9.81-6.54 101.69-6.54 101.69z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M153.37 471.53l-94.53-14.1L60.91 389c1.71-12.31 8.76-13.88 8.76-13.88s68.64-8 89.14 9.68c5.11 8.39-5.44 86.73-5.44 86.73z",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 185.58,
    cy: 497.79,
    rx: 12.9,
    ry: 23.47,
    transform: "rotate(-1.08 -4203.945 2633.278)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 185.57,
    cy: 497.16,
    rx: 12.9,
    ry: 23.47,
    transform: "rotate(-1.08 -4203.94 2632.747)",
    fill: "#dce0ed"
  }), React.createElement("path", {
    d: "M145.91 397.43s-5.27.94-2.39 7.87 3.37 10.51 3.37 10.51 5.34 2.65 5-6.44-5.98-11.94-5.98-11.94z",
    fill: "#f0f0f4"
  }), React.createElement("ellipse", {
    cx: 116.26,
    cy: 489.79,
    rx: 12.05,
    ry: 21.93,
    transform: "rotate(-1.08 -4273.37 2625.196)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 116.25,
    cy: 489.16,
    rx: 12.05,
    ry: 21.93,
    transform: "rotate(-1.08 -4273.365 2624.665)",
    fill: "#dce0ed"
  }), React.createElement("path", {
    d: "M76.6 389.43s-5.27.95-2.39 7.87 3.37 10.51 3.37 10.51 5.34 2.65 5-6.44-5.98-11.94-5.98-11.94z",
    fill: "#f0f0f4"
  }), React.createElement("path", {
    d: "M129.38 395.83c-.68 8.69-3.7 73.05-3.7 73.05l-7.19-1.07-4-.58-5.34-.79-.64-.09-21-3.1 2.84-68.26a8.56 8.56 0 0 1 6.12-7.84 8.88 8.88 0 0 1 2.37-.35h.64c1.44.1 3 .23 4.64.37l2.08.21c2 .2 4.1.45 6.14.75 1 .16 2.07.32 3.08.5 1.71.31 3.37.65 4.9 1.05 1 .26 2 .56 2.93.88 3.81 1.31 6.31 3.08 6.13 5.27z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M98.84 386.8l-2.66 76.71-2.33-.16 2.62-76.2a8.88 8.88 0 0 1 2.37-.35zM106.2 387.4l-2.38 77.45-3.59.07 3.89-77.73zM115.42 388.64l-4.59 77.76h-2.32v-.1l3.83-78.2c1.04.21 2.07.37 3.08.54zM123.25 390.58l-4.76 77.23v.15l-4-.35v-.38l5.83-77.53c1.04.26 2.03.56 2.93.88z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M38.38 451.91s-8.53-40 9.2-42.37 76.15.79 74.72 17.31-2.86 41.62-2.86 41.62l-12.1-2.47s8.32-37.91-5.82-39.07-48.78-4.48-48.78-4.48-9.39-1.4-3.37 31.64z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M38.45 455.72s-8.57-42.51 9.15-44.91 76.16.78 74.73 17.31-2.87 41.62-2.87 41.62l-12.1-2.47s8.33-37.91-5.81-39.07-48.79-4.48-48.79-4.48-9.34 1.13-3.32 34.17z",
    fill: "#dce0ed"
  }), React.createElement("path", {
    d: "M352.86 502.87l-15.65.08c-12.37-50.1-31.78-81-31.78-81-6.41-3.26-75.75-1.53-75.75-1.53-7.17 1.41-8.64 24.28-8.64 24.28s6.24 5.17.38 8.66c-2.62 1.56-11.31 2-21.35 1.69-12.46-.41-27-2-34.54-4.23-13.61-4-3-12-3-12s1.86-2.57 2.86-16.55a56.4 56.4 0 0 1 7.29-23.18c.56-1 .92-1.51.92-1.51a7.47 7.47 0 0 1 2.45-1.6c17.78-7.82 105.77-2.35 105.77-2.35l32.76 9.75c.91.34 2.34 2.61 4.12 6.25 10.73 21.83 34.16 93.24 34.16 93.24z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M352.86 502.87l-15.65.08c-12.37-50.1-31.78-81-31.78-81-6.41-3.26-75.75-1.53-75.75-1.53-7.17 1.41-8.64 24.28-8.64 24.28s6.24 5.17.38 8.66c-2.62 1.56-11.31 2-21.35 1.69-12.46-.41-27-2-34.54-4.23-13.61-4-3-12-3-12s1.86-2.57 2.86-16.55a56.4 56.4 0 0 1 7.29-23.18c.56-1 .92-1.51.92-1.51a7.47 7.47 0 0 1 2.45-1.6c17.78-7.82 105.77-2.35 105.77-2.35l32.76 9.75c.91.34 2.34 2.61 4.12 6.25 10.73 21.83 34.16 93.24 34.16 93.24z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M318.72 409.64c-30.28-11.11-113-3.35-113-3.35-8.94-7.36-25.5-7.54-33-7.19.56-1 .92-1.51.92-1.51a7.47 7.47 0 0 1 2.45-1.6c17.78-7.82 105.77-2.35 105.77-2.35l32.76 9.75c.89.25 2.36 2.56 4.1 6.25z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M210.65 409.32c-1.78 6.59-9.11 33-9.11 33a112.61 112.61 0 0 0-1.47 12.73c-12.46-.41-27-2-34.54-4.23-13.61-4-3-12-3-12s1.86-2.57 2.86-16.55a56.22 56.22 0 0 1 8.21-24.69 7.47 7.47 0 0 1 2.45-1.6c11.82 2.51 35.93 8.35 34.6 13.34z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M210.65 409.32c-1.78 6.59-9.11 33-9.11 33a112.61 112.61 0 0 0-1.47 12.73c-12.46-.41-27-2-34.54-4.23-13.61-4-3-12-3-12s1.86-2.57 2.86-16.55a56.22 56.22 0 0 1 8.21-24.69 7.47 7.47 0 0 1 2.45-1.6c11.82 2.51 35.93 8.35 34.6 13.34z",
    fill: "#fff",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M226.85 242.45c-8.38 1.42-11.7 18.94-11.7 18.94l-21.39 76.7 161.93 23.44 38.83-127.64c-38.22-16.41-167.67 8.56-167.67 8.56zm131.41 79.05s-.81 7.32-7 8.07l-104.74-2.12-21.48-.44-7.21-.14h-.51s-7.9 1.58-6.76-5.11c0 0 7.52-63.59 22.82-68.64 0 0 1.59-.37 4.38-.94 4.38-.92 11.7-2.36 20.33-3.72 3.86-.61 8-1.2 12.23-1.72 11.61-1.4 24.09-2.27 34.45-1.47 0 0 76.94-8.59 71.71 8.64.02-.01-14.99 62.3-18.22 67.59z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M217.85 326.87h-.51s-7.9 1.58-6.76-5.11c0 0 7.52-63.59 22.82-68.64 0 0 1.59-.37 4.38-.94-5.38 10.99-22.6 48.64-19.93 74.69z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M217.85 326.87h-.51s-7.9 1.58-6.76-5.11c0 0 7.52-63.59 22.82-68.64 0 0 1.59-.37 4.38-.94-5.38 10.99-22.6 48.64-19.93 74.69zM234.98 483.05a10.22 10.22 0 0 1-9.46 5.54l-3.23-.08-30.51-.74-11-.26-10.16-.66-134.39-19.21.75-13.23 15.46 1.92 6.39.79 94.87 11.75 12.49 1.55 6.05.75 25.59-.67 27.7-.72a10.34 10.34 0 0 1 4.1.71 10 10 0 0 1 5.46 5 8.41 8.41 0 0 1-.11 7.56z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M235.04 484.32a10.22 10.22 0 0 1-9.46 5.54l-44.73-1.09-10.17-.65-143.35-20.48-11.27-1.61-6.14-.88c-12.1-2.31-8.73-14.43-8.73-14.43.74-5.51 21.36-11 28.13-10.89 4.55.05 5.32 7.05 5.33 11.64 0 2.24-.17 3.91-.17 3.91l6.7.83 131.11 16.23 53.28-1.4a10.25 10.25 0 0 1 9.56 5.71 8.35 8.35 0 0 1-.09 7.57z",
    fill: "#dce0ed"
  }), React.createElement("path", {
    d: "M19.74 447.64s5.84 6.87 14.74 7.76c0-.03-3.74-7.76-14.74-7.76zM18.63 467.3s-18.82-.06-18.65 10.09S12.04 489 12.04 489l168.7 29.18 47.81-.06s16.45-13.63-1-19.23l-48.19 2.18-160.8-26.36s4.12-5.79.07-7.41z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M228.59 519.39l-47.8.06-150-25.94-11-1.9-7.72-1.34S.21 488.8-.02 478.64c-.14-7.28 9.53-9.3 15-9.86 2.15-.22 3.65-.21 3.65-.21 4 1.61-.08 7.4-.08 7.4l5.86 1 155 25.4 48.18-2.18c17.45 5.56 1 19.2 1 19.2z",
    fill: "#dce0ed"
  }), React.createElement("path", {
    d: "M32.64 458.79l9.86-4.63 5.07-.3.41 42.71-15.71-2.87-6.66-4.06-3.51-17.7s1.13-7.42 1.75-8.07 8.79-5.08 8.79-5.08z",
    fill: "#dce0ed"
  }), React.createElement("path", {
    d: "M32.64 458.79l9.86-4.63 5.07-.3.41 42.71-15.71-2.87-6.66-4.06-3.51-17.7s1.13-7.42 1.75-8.07 8.79-5.08 8.79-5.08z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M30.78 493.51l.19.21-11-1.91-.13-.2c-6-9.24-6.61-16.81-4.8-22.82 2.15-.22 3.65-.21 3.65-.21 4 1.61-.08 7.4-.08 7.4l5.86 1c-.27 8.32 5.22 15.23 6.31 16.53zM46.3 453.88a65.34 65.34 0 0 0-5.12 2.32c-7 3.56-11.36 7.49-13.85 11.43l-11.27-1.61c4.68-10.21 16.22-15 16.22-15l2.37.49z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M33.55 450.95s-30.64 12.84-12.34 40.84l11 1.91s-22.23-24.54 15.36-39.84zM107.39 463.3l11.42-.63-1.04 45.91-18.46-3.03-7.9-3.66-3.76-9.02-2.71-9.05 5.98-8.36 6.89-4.78 9.58-7.38z",
    fill: "#dce0ed"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M107.39 463.3l11.42-.63-1.04 45.91-18.46-3.03-7.9-3.66-3.76-9.02-2.71-9.05 5.98-8.36 6.89-4.78 9.58-7.38z"
  }), React.createElement("ellipse", {
    cx: 147.59,
    cy: 569.37,
    rx: 5.5,
    ry: 9.3,
    transform: "rotate(-1.08 -4241.76 2705.076)",
    fill: "#dce0ed"
  }), React.createElement("path", {
    d: "M67.15 513.71c-1.74-8.05-8-9.68-8-9.68s-12-3.27-12 9.9c0 0 .31 8.09 5.75 10.52l.49 9s.63 8.39-4.14 7.69-4.27-8.13-4.27-8.13-2.69-7.88-8.79-3.64c0 0-1.35 4.47 1.87 6.63 1.87 1.26 2 3.9 1.76 5.88a8.6 8.6 0 0 0 2.16 6.85 8 8 0 0 0 7.68 2.59 11.81 11.81 0 0 0 6.53-3.92 17.26 17.26 0 0 0 4.36-11.64v-11.61s8.34-2.38 6.6-10.44zm-9.6 8.35a6.74 6.74 0 1 1 6.62-6.86 6.73 6.73 0 0 1-6.62 6.86z",
    fill: "#dce0ed"
  }), React.createElement("path", {
    d: "M54.38 500.64a3 3 0 0 0-1.4 4.18c1.29 2.31 2.84 5.3 2.72 6.1-.22 1.35 2.78.18 3.17-.14s5.86-.11 6.11-3.85a6.44 6.44 0 0 0-3-5.65l1.11-8.19-7.6-.45.22 7.45z",
    fill: "#636780"
  }), React.createElement("path", {
    d: "M54.38 500.64a3 3 0 0 0-1.4 4.18c1.29 2.31 2.84 5.3 2.72 6.1-.22 1.35 2.78.18 3.17-.14s5.86-.11 6.11-3.85a6.44 6.44 0 0 0-3-5.65l1.11-8.19-7.6-.45.22 7.45z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M56.43 500.43s2.7 8.68 1.6 9-1.6-9-1.6-9zM59.25 498.32s2.7 8.67 1.59 9-1.59-9-1.59-9z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M89.15 471.47l-3.74 26.3s-5.25-.62-8.14-1.18a6.1 6.1 0 0 1-1.84-.53c-.14-.15-.45-.13-.87 0-1.4.31-3.89 1.53-4.4.56a.7.7 0 0 0-.14-.21c-.51-.53-1.46-.12-2.39 0a2 2 0 0 1-1.48-.17c-.79-.5-2.36.36-3.65.67-.81.19-1.52.17-1.85-.56a1.72 1.72 0 0 0-1.28-.88c-1.22-.28-2.93 0-3.91-.23-.39-.07-.66-.21-.75-.48-.21-.56-1.3-.81-2.47-1-1.42-.25-2.95-.42-3.07-1 0-.19-.18-.27-.39-.28a13.2 13.2 0 0 0-2.3.62c-.63.17-1.16.19-1.32-.27s-.9-.43-1.73-.21c-.67.18-1.4.46-2 .6s-.88.15-1-.09c-.23-.84-2.94 1.11-3.6-.57s-9.55-12.72 1.38-27.52c0 0 3 .15 5.36.53a8 8 0 0 1 2.24.59c.8.44 2.53.3 4.08.39a5.26 5.26 0 0 1 2.28.5 1.48 1.48 0 0 1 .65.66c.37.8 1.18.95 2.07.88 1.2-.09 2.52-.57 3-.34.89.36 4.2-.07 4.78.47.25.35 1.54 0 2.87-.25a3.24 3.24 0 0 1 2.64.37 3 3 0 0 0 2.07.57 11.68 11.68 0 0 1 2.69 0 1.1 1.1 0 0 1 .54.33c.55.65 1.84.54 3 .58a3 3 0 0 1 1.69.39 1.5 1.5 0 0 0 .61.24 18 18 0 0 0 5.1-.35z",
    fill: "#636780"
  }), React.createElement("path", {
    d: "M43.4 492.64c-.67.18-1.4.46-2 .6-8.84-13.16-1.8-23.41 2.19-27.65a8 8 0 0 1 2.24.59c-8.4 10.08-4.16 22.46-2.43 26.46z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M48.76 492.47a13.2 13.2 0 0 0-2.3.62c-7.6-12.86-.22-22.72 3.53-26.54a5.26 5.26 0 0 1 2.28.5c-8.07 9.15-5.41 20.29-3.51 25.42z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M55.44 495.23c-.39-.07-.66-.21-.75-.48-.21-.56-1.3-.81-2.47-1-6.67-11.67-1.07-20.81 2.76-25.11 1.2-.09 2.52-.57 3-.34-8.85 10.34-4.21 23.17-2.54 26.93z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M62.49 496.9c-.81.19-1.52.17-1.85-.56a1.72 1.72 0 0 0-1.28-.88c-7.77-13-.29-22.91 3.47-26.72.25.35 1.54 0 2.87-.25-10.45 11.04-4.72 25.26-3.21 28.41z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M69.98 496.36c-.51-.53-1.46-.12-2.39 0-8.08-12.87-1.07-22.83 2.82-26.92a11.68 11.68 0 0 1 2.69 0c-8.93 10.11-4.92 22.58-3.12 26.92z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M77.27 496.64a6.1 6.1 0 0 1-1.84-.53c-.14-.15-.45-.13-.87 0-7.17-11.75-1.8-21 2.1-25.58a3 3 0 0 1 1.69.39 1.5 1.5 0 0 0 .61.24c-7.41 9.86-3.37 21.58-1.69 25.48z",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 323.62,
    cy: 594.38,
    rx: 34.47,
    ry: 50.75,
    transform: "translate(-52.18 -76.14)",
    fill: "#636780"
  }), React.createElement("ellipse", {
    cx: 322.47,
    cy: 595.15,
    rx: 25.06,
    ry: 41.13,
    transform: "rotate(-1.08 -4066.394 2731.134)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 322.44,
    cy: 593.88,
    rx: 25.06,
    ry: 41.13,
    transform: "rotate(-1.08 -4066.379 2729.543)",
    fill: "#f0f0f4"
  }), React.createElement("ellipse", {
    cx: 326.47,
    cy: 566.2,
    rx: 2.96,
    ry: 5.08,
    transform: "rotate(-1.08 -4062.405 2701.991)",
    fill: "#636780"
  }), React.createElement("ellipse", {
    cx: 339.15,
    cy: 610.38,
    rx: 2.96,
    ry: 5.08,
    transform: "rotate(-1.08 -4050.088 2746.143)",
    fill: "#636780"
  }), React.createElement("ellipse", {
    cx: 306.82,
    cy: 589.84,
    rx: 2.96,
    ry: 5.08,
    transform: "rotate(-1.08 -4082.259 2725.679)",
    fill: "#636780"
  }), React.createElement("ellipse", {
    cx: 316.05,
    cy: 619.27,
    rx: 2.96,
    ry: 5.08,
    transform: "rotate(-1.08 -4072.985 2754.947)",
    fill: "#636780"
  }), React.createElement("path", {
    d: "M533.07 413.38s26 65.5 24.79 69.65c0 0 10.59 6.15 13.09 4.51s-.26-30.77-.26-30.77l-5.24-25.6-5.68-15.12z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M533.07 413.38s26 65.5 24.79 69.65c0 0 10.59 6.15 13.09 4.51s-.26-30.77-.26-30.77l-5.24-25.6-5.68-15.12z",
    opacity: 0.15
  }), React.createElement("ellipse", {
    cx: 342.86,
    cy: 582.81,
    rx: 2.96,
    ry: 5.08,
    transform: "rotate(-1.08 -4046.115 2718.592)",
    fill: "#636780"
  }), React.createElement("ellipse", {
    cx: 327.02,
    cy: 595.38,
    rx: 8.67,
    ry: 12.05,
    transform: "rotate(-1.08 -4062.15 2731.174)",
    fill: "#636780"
  }), React.createElement("path", {
    d: "M562.33 501.03c.72 38.19-11.31 73.19-46.59 70-44.42-.11-48.47-30-49.19-68.23s20.18-67 46.63-67.51 48.42 27.56 49.15 65.74z",
    fill: "#636780"
  }), React.createElement("path", {
    d: "M562.6 501.09c-.55-29.56-13.86-53-32.11-61.88-23.13 4.85-40.47 31.89-39.81 66.73.59 31.29 3.42 57 28.87 65.38 32.55.55 43.75-33.35 43.05-70.23z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M580.73 484.5s-6.24 5.51-9.8 1.77c0 0-9.86-68.34-20.65-68.45l-37.11.38s-4.4 2-6.15 10.27l-22.71 68.75-131.48 4.42-10.44-20.86 108.79-1.73c.55-2.12 17.49-67.37 29.56-75.67a5.48 5.48 0 0 1 1.32-.67s45.24-6.89 60.23-3c0 0 15.6 3.19 19.5 7.88.52.53 6.53 7 8.71 26.13z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M580.76 485.77s-6.24 5.51-9.81 1.77c0 0-9.85-68.34-20.64-68.46l-37.11.39s-4.41 2-6.16 10.27l-22.7 68.75-131.48 4.38-10.44-20.85 108.79-1.73v-.06c.55-2.11 17.5-67.36 29.56-75.66a5.78 5.78 0 0 1 1.33-.68s45.24-6.88 60.22-3c0 0 15.61 3.2 19.5 7.88.52.53 6.53 7 8.71 26.13z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M580.76 485.77s-6.24 5.51-9.81 1.77c0 0-9.85-68.34-20.64-68.46l-37.11.39s-4.41 2-6.16 10.27l-22.7 68.75-131.48 4.38-10.44-20.85 108.79-1.73v-.06c.55-2.11 17.5-67.36 29.56-75.66a5.78 5.78 0 0 1 1.33-.68s45.24-6.88 60.22-3c0 0 15.61 3.2 19.5 7.88.52.53 6.53 7 8.71 26.13z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M498.79 412.44c-3.06 6.09-28.94 80.82-28.94 80.82l-18.64-13v-.06c.55-2.11 17.51-67.43 29.58-75.68 7.98 1.24 20.07 3.79 18 7.92z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M462.62 379.18l-14 49.12-77.75-.75.78 7.28s61.06 7.73 86.84-4.81l13.11-44.88 122.64-1.68-23.46-5.06z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M462.62 379.18l-14 49.12-77.75-.75.78 7.28s61.06 7.73 86.84-4.81l13.11-44.88 122.64-1.68-23.46-5.06z",
    fill: "#fff",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M99.77 463.02s-41.26 21.72-10 40.8l8.29 1.75s-30.65-21.21 19.49-42.88z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M101.04 463s-41.26 21.72-10 40.8l8.29 1.75s-30.67-21.21 19.47-42.91z",
    fill: "#dce0ed"
  }), React.createElement("ellipse", {
    cx: 573.95,
    cy: 589.34,
    rx: 23.16,
    ry: 39.65,
    transform: "rotate(-1.08 -3814.856 2725.016)",
    fill: "#636780"
  }), React.createElement("ellipse", {
    cx: 573.19,
    cy: 590.21,
    rx: 16.83,
    ry: 32.13,
    transform: "translate(-52.06 -71.43)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 573.16,
    cy: 588.94,
    rx: 16.83,
    ry: 32.13,
    transform: "rotate(-1.08 -3815.382 2724.48)",
    fill: "#f0f0f4"
  }), React.createElement("ellipse", {
    cx: 575.81,
    cy: 567.33,
    rx: 1.99,
    ry: 3.97,
    transform: "rotate(-1.08 -3812.53 2703.285)",
    fill: "#636780"
  }), React.createElement("ellipse", {
    cx: 584.42,
    cy: 601.87,
    rx: 1.99,
    ry: 3.97,
    transform: "rotate(-1.08 -3804.366 2737.848)",
    fill: "#636780"
  }), React.createElement("ellipse", {
    cx: 562.66,
    cy: 585.75,
    rx: 1.99,
    ry: 3.97,
    transform: "rotate(-1.08 -3825.967 2721.728)",
    fill: "#636780"
  }), React.createElement("ellipse", {
    cx: 568.92,
    cy: 608.77,
    rx: 1.99,
    ry: 3.97,
    transform: "rotate(-1.08 -3819.816 2744.6)",
    fill: "#636780"
  }), React.createElement("ellipse", {
    cx: 586.85,
    cy: 580.34,
    rx: 1.99,
    ry: 3.97,
    transform: "rotate(-1.08 -3801.509 2716.122)",
    fill: "#636780"
  }), React.createElement("ellipse", {
    cx: 576.24,
    cy: 590.12,
    rx: 5.82,
    ry: 9.42,
    transform: "rotate(-1.08 -3812.214 2726.102)",
    fill: "#636780"
  }), React.createElement("path", {
    d: "M193.42 336.99s70.45 1.21 162.27 24.54z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M526.98 207.39s-3.81.68-1.73 5.69a34.5 34.5 0 0 1 2.44 7.6s3.86 1.92 3.59-4.65-4.3-8.64-4.3-8.64z",
    fill: "#dce0ed"
  })), React.createElement("path", {
    d: "M534.74 664.73a5.81 5.81 0 0 1-4.33-2.62c-4.33-6.55-15.82-25.24-7.75-27.82a31.93 31.93 0 0 1 3.91-1 39.78 39.78 0 0 1 38.56 15.07 36.31 36.31 0 0 1 3.16 4.82 5 5 0 0 1-3 7.15c-7.12 2.1-20.31 5.31-30.55 4.4z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: "#33323d",
    d: "M526.77 663.7l44.02-7.96h65.92l-9.42 14.52h-91.55l-8.97-6.56z"
  }), React.createElement("path", {
    d: "M560.22 196.64c4.94-2.51 11.38 0 17.26.59 7.62.74 15.17-2 22.84-1.79a28.65 28.65 0 0 1 18.74 7.74 22.9 22.9 0 0 1 6.9 15.71 18.28 18.28 0 0 1-2.41 10.1c-3.66 6.09-12 10.22-20.65 10.91a38.65 38.65 0 0 1-24.12-6.33c-5.68-3.86-9.64-9-14.45-13.46-3.42-3.21-12.42-7.26-12.49-11.43-.05-2.89 5.26-10.48 8.38-12.04z",
    fill: "#4c4981"
  }), React.createElement("path", {
    d: "M560.22 196.64c4.94-2.51 11.38 0 17.26.59 7.62.74 15.17-2 22.84-1.79a28.65 28.65 0 0 1 18.74 7.74 22.9 22.9 0 0 1 6.9 15.71 18.28 18.28 0 0 1-2.41 10.1c-3.66 6.09-12 10.22-20.65 10.91a38.65 38.65 0 0 1-24.12-6.33c-5.68-3.86-9.64-9-14.45-13.46-3.42-3.21-12.42-7.26-12.49-11.43-.05-2.89 5.26-10.48 8.38-12.04z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M578.54 625.9l-.68 14a188.19 188.19 0 0 1 19.87-.38c.54-2.1 0-4.31-.44-6.45a48.71 48.71 0 0 1-.81-12.52c.08-1.15-12.3-2.33-13.55-2.39-1.52-.06-3.1-.27-3.83 1.32-.81 1.74-.47 4.52-.56 6.42z",
    fill: "#4c4981"
  }), React.createElement("path", {
    d: "M562.23 630.41l-.67 14a188 188 0 0 1 19.86-.38c.54-2.1 0-4.31-.44-6.45a49.16 49.16 0 0 1-.8-12.52c.07-1.16-12.3-2.33-13.55-2.39-1.53-.06-3.1-.27-3.83 1.32-.82 1.74-.48 4.52-.57 6.42z",
    fill: "#4c4981"
  }), React.createElement("path", {
    d: "M593.09 625.42a7.42 7.42 0 0 0-2.54 1.58l-5 4.18c-1.68 1.41-3.89 2.9-5.9 2a13.63 13.63 0 0 1-2.34-1.84 2.3 2.3 0 0 0-2.74-.31 2.82 2.82 0 0 0-.77 1.73 133.48 133.48 0 0 0-2.17 26.92 15.93 15.93 0 0 0 4.87 1.08.84.84 0 0 0 .54-.1c.29-.24.13-.7.09-1.07-.14-1.29 1.66-2.05 2.83-1.49a5.59 5.59 0 0 1 2.3 3 3 3 0 0 0 .86 1.29 2.89 2.89 0 0 0 1.19.43 42.83 42.83 0 0 0 6.88.63q16 .55 32 0a10.62 10.62 0 0 0 3.28-.46 6.24 6.24 0 0 0 3.82-4.84 8.62 8.62 0 0 0-1.52-6.13 10.52 10.52 0 0 0-3.51-3.22 20.54 20.54 0 0 0-3.31-1.4l-5-1.8c-3.65-1.3-7.43-2.69-10.15-5.44a25.86 25.86 0 0 1-3.82-5.52c-1.89-3.21-4.84-10.7-9.89-9.22z",
    fill: "#4c4981"
  }), React.createElement("path", {
    d: "M593.09 625.42a7.42 7.42 0 0 0-2.54 1.58l-5 4.18c-1.68 1.41-3.89 2.9-5.9 2a13.63 13.63 0 0 1-2.34-1.84 2.3 2.3 0 0 0-2.74-.31 2.82 2.82 0 0 0-.77 1.73 133.48 133.48 0 0 0-2.17 26.92 15.93 15.93 0 0 0 4.87 1.08.84.84 0 0 0 .54-.1c.29-.24.13-.7.09-1.07-.14-1.29 1.66-2.05 2.83-1.49a5.59 5.59 0 0 1 2.3 3 3 3 0 0 0 .86 1.29 2.89 2.89 0 0 0 1.19.43 42.83 42.83 0 0 0 6.88.63q16 .55 32 0a10.62 10.62 0 0 0 3.28-.46 6.24 6.24 0 0 0 3.82-4.84 8.62 8.62 0 0 0-1.52-6.13 10.52 10.52 0 0 0-3.51-3.22 20.54 20.54 0 0 0-3.31-1.4l-5-1.8c-3.65-1.3-7.43-2.69-10.15-5.44a25.86 25.86 0 0 1-3.82-5.52c-1.89-3.21-4.84-10.7-9.89-9.22z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M640.86 399.28q0 4.28-.18 8.57a431.62 431.62 0 0 1-4.7 52.27c-.6 3.89-1.25 7.77-2.2 11.58-1.37 5.45-3.39 10.76-4 16.36-.83 8 1.31 16.25-.5 24.09-.93 4-2.87 7.73-4 11.69a62.67 62.67 0 0 0-1.58 7.19q-1.51 8.4-3 16.77c-.11.57-.21 1.14-.31 1.71a68.86 68.86 0 0 1-6.56 18.9 59.74 59.74 0 0 0-4 11.58q-2.67 9.93-5.34 19.88c-2.41 8.95-4.83 18.3-3 27.39a63.56 63.56 0 0 1-10.84-1.62 61.16 61.16 0 0 1-13.13-4.82c-.94-15.43-.25-30.9.43-46.35.44-9.79.88-19.6 2.53-29.26 1.79-10.53 4.24-20.58 6.38-31.05 3.21-15.67 6.44-31.47 6.13-47.46-.38-20.71.16-41.8 9.19-60.43a13.81 13.81 0 0 1 4.18-5.66 14.38 14.38 0 0 1 6-2 113.4 113.4 0 0 1 21.77-1.56 15.22 15.22 0 0 1 6.73 2.23z",
    fill: "#33323d"
  }), React.createElement("path", {
    d: "M640.86 399.28c0 2.85-21.64.67-21.74 3.52-26.58-3.08-14.13 3.1-15.3 3.93-2.52 1.77 9.58-1.79 7.06 0-2.19 1.55-5.59 7.57-7.85 9-5.27 3.45 12.3 14.07 8.39 19-3.55 4.46-4.38 10.54-3.91 16.2s2.12 11.17 3 16.8a62.85 62.85 0 0 1-3.31 31.68c-2.28 6.05-5.48 11.69-8.39 17.46-3.18 6.35-9.06 12.66-8.36 19.74 1.61 15.94-1.17 32-1.92 48-.29 6.12-.28 12.36 1.42 18.25.64 2.25 1.53 4.43 2 6.72 1.19 5.31.25 10.81-1.32 16.08a61.16 61.16 0 0 1-13.13-4.82c-.94-15.43-.25-30.9.43-46.35.44-9.79.88-19.6 2.53-29.26 1.79-10.53 4.24-20.58 6.38-31.05 3.21-15.67 6.44-31.47 6.13-47.46-.38-20.71.16-41.8 9.19-60.43a13.81 13.81 0 0 1 4.18-5.66 14.38 14.38 0 0 1 6-2 113.4 113.4 0 0 1 21.77-1.56 15.22 15.22 0 0 1 6.75 2.21z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M642.45 385.05c0 5.08 2.84 16.32-1.05 19.58-2.59 2.19-5.79 3.52-8.57 5.47-2.52 1.77-4.67 4-7.18 5.83-2.19 1.55-4.63 2.71-6.88 4.18-5.28 3.45-7.59 9.72-11.51 14.64-3.54 4.46-4.37 10.54-3.9 16.2s2.12 11.17 3 16.8a63 63 0 0 1-3.31 31.68c-2.29 6.05-5.48 11.69-8.39 17.46-3.18 6.35-9.07 12.66-8.36 19.74 1.61 15.94-1.18 32-1.92 48-.29 6.12-.28 12.36 1.42 18.25.64 2.25 1.52 4.43 2 6.72 1.39 6.27-.17 12.82-2.22 18.91-7.06-1.24-14.2-2.47-21.34-1.94-6.27.47-12.5 2.28-18.74 1.53-.75-16.84.79-33.7 2.31-50.49.3-3.43.62-6.86.93-10.3 1.2-13.15 2.39-26.31 3.1-39.51.18-3.33-1-6.86-.06-10.07q2.93-10.09 5.86-20.09a66.24 66.24 0 0 0 2.34-10.21c.88-7.15-.58-14.36-2-21.41q-3-14.48-6-29c-.66-3.21-1.33-6.43-2.24-9.6a61.8 61.8 0 0 1-1.69-6.38 82 82 0 0 1-.56-9.14c-.3-5.27-1.53-10.43-1.92-15.69a32.06 32.06 0 0 1 .24-7.58 19.16 19.16 0 0 1 2.83-7.64 233.82 233.82 0 0 1 45.56-13 64 64 0 0 1 11-1.28 73.6 73.6 0 0 1 12.54 1.39c5.78 1 11.67 2 17 4.6a25.13 25.13 0 0 1 6.9 4.8c2.68 2.69 1-3.52 1.86.18.24 1.28-1.07 6.09-1.05 7.37z",
    fill: "#33323d"
  }), React.createElement("path", {
    d: "M576.79 629.92a7.51 7.51 0 0 0-2.54 1.59l-5 4.18c-1.69 1.41-3.9 2.9-5.9 2a13.26 13.26 0 0 1-2.34-1.84 2.29 2.29 0 0 0-2.74-.31 2.82 2.82 0 0 0-.77 1.73 132 132 0 0 0-2.17 26.92 15.93 15.93 0 0 0 4.86 1.08.83.83 0 0 0 .54-.1c.3-.24.14-.7.1-1.07-.14-1.29 1.66-2.06 2.82-1.49a5.59 5.59 0 0 1 2.3 3 3.12 3.12 0 0 0 .86 1.29 2.89 2.89 0 0 0 1.19.43 42.85 42.85 0 0 0 6.89.63c10.66.37 21.35.38 32 0a10.73 10.73 0 0 0 3.29-.46 6.24 6.24 0 0 0 3.81-4.85 8.56 8.56 0 0 0-1.52-6.12 10.58 10.58 0 0 0-3.5-3.22 21 21 0 0 0-3.32-1.4l-5-1.8c-3.64-1.31-7.42-2.69-10.15-5.45a25.91 25.91 0 0 1-3.83-5.52c-1.89-3.2-4.84-10.69-9.88-9.22z",
    fill: "#4c4981"
  }), React.createElement("path", {
    d: "M625.92 222.8a10 10 0 0 1-2.09 4.28c-2.16 3-4.55 6.17-8.05 7.36a16.22 16.22 0 0 1-6 .54 78.88 78.88 0 0 1-47.32-18.84c6.27-4.14 9.61-11.68 10.43-19.14a62.82 62.82 0 0 0-1-17.34c-.29-1.69-.59-3.37-.89-5-.56-3.06-2-5.43 1.49-6.28 2.71-.67 6.39-.2 9.16 0 6.09.34 12.31 1.66 17.26 5.39a11.65 11.65 0 0 1 3.33 3.63c2.13 4 .4 8.71-.1 13.3a18.26 18.26 0 0 0-.07 3.13c.39 5.09 3.81 9.48 7.74 12.73s8.47 5.75 12.3 9.1c2.14 1.8 4.19 4.33 3.81 7.14z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M602.13 190.64a29 29 0 0 1-6.63.76 29.57 29.57 0 0 1-23.62-11.76c-.29-1.69-.59-3.37-.89-5-.56-3.06-2-5.43 1.49-6.28 2.71-.67 6.39-.2 9.16 0 6.09.34 12.31 1.66 17.26 5.39a11.65 11.65 0 0 1 3.33 3.63c2.13 3.95.4 8.66-.1 13.26z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 595.51,
    cy: 160.38,
    r: 29.63,
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M644.26 380.22c-.18.4-1.59 7.21-1.81 7.6-9.86-2-16-2.15-26-2a40.86 40.86 0 0 0-7.57.63c-2.1.42-4.15 1.11-6.27 1.44-11.42 1.76-22.23-7.17-33.76-6.29-3.85.29-7.53 1.67-11.14 3-4 1.52-8 2.68-11.9 4a19.16 19.16 0 0 1 2.83-7.64 233.82 233.82 0 0 1 45.56-13 64 64 0 0 1 11-1.28 73.6 73.6 0 0 1 12.54 1.39c5.78 1 11.67 2 17 4.6a25.13 25.13 0 0 1 6.9 4.8c2.62 2.75 1.81-.95 2.62 2.75z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M585.62 220.88c-.62-3-2.67-5.39-4.69-7.65q-5.72-6.4-11.82-12.47a16.93 16.93 0 0 0-4.6-3.59 6 6 0 0 0-5.63.05c-1.54 1-2.32 2.76-3.55 4.1-2.66 2.91-7.29 3.6-9.53 6.85a18.13 18.13 0 0 1-1.71 2.59 7.6 7.6 0 0 1-3.35 1.65l-14.12 4.23c-1.66.49-3.5 1.13-4.29 2.67a8.64 8.64 0 0 0-.63 2.57c-1.12 6.39-6.75 10.83-11.7 15-1.72 1.45-3.46 3.05-4.19 5.17s-.35 4.37.1 6.53c1.13 5.49 2.78 11 6 15.61 2.12 3.12 4.9 5.8 6.65 9.14a31.31 31.31 0 0 1 2.76 10.1c1 6.57 1.52 13.19 2.08 19.81.49 5.82-.21 12.36 1.48 18 2.06 6.85 9.41 10.75 12.67 17.12a32 32 0 0 1 2.51 8.42l3.13 15.86a35 35 0 0 1 .93 7.33c-.08 5.83-3.07 11.51-2.13 17.26 5.29-2 10.39-3.37 15.67-5.36 3.62-1.37 7.3-2.76 11.16-3.05 11.52-.86 22.33 8.06 33.75 6.3 2.12-.32 4.17-1 6.27-1.43a41.68 41.68 0 0 1 7.57-.65 143.39 143.39 0 0 1 30 2.71c2-3.35 2.33-7.46 1.84-11.33s-1.74-7.59-2.72-11.37a84.15 84.15 0 0 1-2.22-30.41 66.85 66.85 0 0 0 .69-7.73c0-9.66-5.86-18.71-5.32-28.36.53-9.49 11.37-14.8 15.85-23.2a10.08 10.08 0 0 0 1.49-5.58c-.22-2-1.48-3.8-2.29-5.68-2-4.61-1.26-9.92-2.4-14.8-.41-1.71-1-3.36-1.42-5.08-1-4.74-.09-9.78-1.3-14.48-.94-3.64-3.12-6.83-5.44-9.78-3.92-5-8.5-9.67-14.22-12.43s-12.76-3.35-18.35-.33a7 7 0 0 0-2.26 1.79 8.91 8.91 0 0 0-1.24 2.92 90.62 90.62 0 0 1-8.21 19.13 8.88 8.88 0 0 1-7.26-2.17c-2.02-1.72-5.48-3.42-6.01-5.98z",
    fill: "#4c4981"
  }), React.createElement("path", {
    d: "M581.24 169.27a9.6 9.6 0 0 0 .72-4.2 6.62 6.62 0 0 1 1.12-4.06c1.16-1.41 3.24-1.79 4.35-3.22 1.27-1.63.84-3.94 1.22-6a7.53 7.53 0 0 1 7-6c2.48-.07 4.81 1.11 7.25 1.59 3.17.63 6.44.06 9.62-.5 2.37-.42 5-.95 6.48-2.81a9.79 9.79 0 0 0 1.72-4.24c.53-2.39.93-5.05-.3-7.16s-3.83-3.14-5.2-5.19c-1.19-1.79-1.29-4.15-2.5-5.93-1.88-2.78-5.8-3.27-9.13-2.85s-6.71 1.48-10 .77c-3.62-.78-7.2-3.63-10.61-2.2-2.51 1.06-3.56 3.95-5.1 6.2a13.48 13.48 0 0 1-5.27 4.52c-3.26 1.57-7.08 1.79-10.21 3.61a11.44 11.44 0 0 0-5.42 7.84 3.29 3.29 0 0 0 .06 1.79 8.3 8.3 0 0 0 .79 1.26c1.3 2.06.46 4.81-.8 6.89s-2.94 4-3.34 6.45.55 4.84 1.78 6.95a50 50 0 0 1 3.69 6.31c1.07 2.61 1.27 5.5 2.34 8.1a13.12 13.12 0 0 0 9.79 7.78 3 3 0 0 0 2.39-.36 3.06 3.06 0 0 0 .89-1.7 19.3 19.3 0 0 0 .57-3.37c.17-2.24 0-4.83 1-6.9 1.24-2.59 3.76-.84 5.1-3.37z",
    fill: "#33323d"
  }), React.createElement("path", {
    d: "M620.37 132.75c-1.24-2.12-3.83-3.14-5.2-5.19-1.19-1.79-1.29-4.15-2.5-5.93a6.48 6.48 0 0 0-3.74-2.53c1.21 1.78 1.3 4.14 2.5 5.93 1.36 2.05 3.95 3.06 5.19 5.19s.83 4.77.3 7.16a9.83 9.83 0 0 1-1.71 4.24c-1.54 1.85-4.12 2.39-6.49 2.81-3.18.56-6.45 1.12-9.62.5-2.43-.49-4.76-1.66-7.25-1.59a7.51 7.51 0 0 0-6.94 5.95c-.38 2 0 4.34-1.22 6-1.12 1.43-3.2 1.81-4.35 3.21a6.68 6.68 0 0 0-1.13 4.07 9.53 9.53 0 0 1-.71 4.19c-1.35 2.54-3.87.78-5.14 3.37-1 2.07-.83 4.66-1 6.9a19.41 19.41 0 0 1-.57 3.38 3.11 3.11 0 0 1-.88 1.7 3 3 0 0 1-2.39.36 12.65 12.65 0 0 1-3-.92 13 13 0 0 0 6.75 3.43 3 3 0 0 0 2.39-.36 3.06 3.06 0 0 0 .89-1.7 19.3 19.3 0 0 0 .57-3.37c.17-2.24 0-4.83 1-6.9 1.28-2.59 3.8-.84 5.14-3.37a9.6 9.6 0 0 0 .72-4.2 6.62 6.62 0 0 1 1.12-4.06c1.16-1.41 3.24-1.79 4.35-3.22 1.27-1.63.84-3.94 1.22-6a7.51 7.51 0 0 1 7-5.94c2.48-.08 4.81 1.1 7.25 1.58 3.17.63 6.44.06 9.62-.5 2.37-.42 5-.95 6.48-2.81a9.79 9.79 0 0 0 1.72-4.24c.46-2.37.86-5.03-.37-7.14z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M556.4 686.7c0 10.09-7.06 18.27-15.76 18.27s-15.75-8.18-15.75-18.27v-.14c.07-10 7.1-18.13 15.75-18.13 5.35 0 10.07 3.08 12.91 7.82a20.07 20.07 0 0 1 2.85 10.45zM681.98 694.06c0 19.43-10.05 35.19-22.44 35.19s-22.42-15.76-22.42-35.19c0-11 3.2-20.79 8.22-27.23 3.88-5 8.8-8 14.2-8a15 15 0 0 1 2.22.16c4.45.69 8.54 3.42 11.83 7.6a21.56 21.56 0 0 1 1.3 1.79c4.36 6.46 7.09 15.58 7.09 25.68zM668.62 653.78l-19.61 1.96-2.52-20.96-.17-1.37-3.56-29.54-.16-1.37-18.01-149.43-.39-3.18-10.74-89.19-.26-2.13-1.12-9.32-.75-6.19h15.7l.85 6.41.14 1.02.39 2.87 13.47 100.66.36 2.7 19.21 143.51 4.21 31.45 2.96 22.1z",
    fill: "#33323d"
  }), React.createElement("path", {
    d: "M659.52 658.88a15 15 0 0 1 2.22.16l-.56.38a12.59 12.59 0 0 0-5 11.65l3.18 30.24a3.83 3.83 0 0 1 0 .47 4.56 4.56 0 0 1-9 .86c-1.31-6.93-3.79-21.09-4.91-33.88-.06-.68-.1-1.32-.1-1.93 3.85-4.96 8.77-7.95 14.17-7.95zM665.18 668.43l-.69-.2c-.21-.55-.4-1.09-.61-1.59a21.56 21.56 0 0 1 1.3 1.79z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M658.41 650.64s-15.95-1-14.38 16.74c1.13 12.79 3.61 26.94 4.91 33.87a4.56 4.56 0 0 0 5.17 3.66 4.56 4.56 0 0 0 3.85-5l-3.18-30.24a12.58 12.58 0 0 1 5-11.66c3.77-2.65 8.8-2.81 13 8.82l2.88.79s3.68-19.08-17.25-16.98z",
    fill: "#504f60"
  }), React.createElement("path", {
    d: "M641.87 454.02a12.77 12.77 0 0 1-2.4.24h-5.62a12.91 12.91 0 0 1-12.79-11.48l-8.6-78.27a12.9 12.9 0 0 1 15.56-14z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M642.23 456.72a12.1 12.1 0 0 1-2.76.31h-5.62a12.76 12.76 0 0 1-9.26-4l-.39-3.19-10.74-89.18a12.82 12.82 0 0 1 14.95-7.35l13.46 100.67z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M612.46 365.89c2.07 18.83 6.44 58.64 8.6 78.29a12.86 12.86 0 0 0 12.79 11.46h5.61a12.63 12.63 0 0 0 12.15-8.63 11.07 11.07 0 0 0 .53-3.34c0-6-6.44-60.35-8.44-77.11a12.69 12.69 0 0 0-4.74-8.51 45.31 45.31 0 0 0-8.51-5.33c-8.99-4.18-19.07 3.31-17.99 13.17z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M553.55 676.25l-4.22-.18a19.61 19.61 0 0 0-10.73 2.63l-13.2 7.6c-.17.09-.35.19-.51.26.07-10 7.1-18.13 15.75-18.13 5.34 0 10.07 3.08 12.91 7.82zM665.66 633.06l-19.17 1.72-.17-1.37-3.56-29.54 18.69-2.25 4.21 31.44z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M646.3 633.41c3.08 45-28.43 44.17-28.43 44.17l-68.53-2.94a19.8 19.8 0 0 0-10.74 2.63l-13.2 7.61a6.87 6.87 0 0 1-7.7-.57 6.88 6.88 0 0 1-1.23-9.51l5.58-7.44a11.66 11.66 0 0 1 10-4.64l71.71 4.09c29 .52 38.84-64.35 38.84-64.35l18.86-2.27 4.2 31.45-19.33 1.73z",
    fill: "#504f60"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M627.88 349.47l-15.8-.22-.75-6.19h15.7l.85 6.41z"
  }), React.createElement("path", {
    d: "M551.62 337.25l132.58 3.32a4.15 4.15 0 0 1 4 4.15 4.14 4.14 0 0 1-4.2 4.14l-132.57-1.85a4.14 4.14 0 0 1-4.08-4.14v-1.48a4.14 4.14 0 0 1 4.27-4.14z",
    fill: "#33323d"
  }), React.createElement("path", {
    d: "M560.77 325.46c4.62.94 9.73.69 13.6 3.4 3.45 2.41 5.12 6.76 5.31 11s-.92 8.35-2 12.42c-.34 1.28-1 2.83-2.34 2.87s-2-1.32-3.07-2c-2.3-1.4-5.55.67-7.87-.69a12.86 12.86 0 0 1-1.82-1.65 6 6 0 0 0-6.73-.8 10.8 10.8 0 0 0-10.92-12.79c-1.8.06-3.73.53-5.3-.34-2.53-1.38-2.32-5.18-1-7.72 1.92-3.57 3.38-7.07 7.74-7.07 5 .02 9.61 2.4 14.4 3.37zM651.07 330.43l-.06 9.72c0 3.66 0 7.5 1.81 10.69.94 1.66 2.56 3.16 4.48 3.12.72 0 1.42-.24 2.14-.21 2.09.08 4 2.28 5.95 1.55.66-.25 1.19-.81 1.87-1 1-.3 2.15.26 3.16-.05s1.61-1.47 2-2.49c2-4.88 4-10.26 2.55-15.32a23.62 23.62 0 0 0-3.41-6.35l-6.48-9.59a3.28 3.28 0 0 0-1.06-1.13 2.87 2.87 0 0 0-1.45-.26c-3.22 0-6.23 1.52-9.11 3s-2.37 5.53-2.39 8.32z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M657.42 276.39a27.4 27.4 0 0 0 1.82 6.21c1.14 2.27 3.16 4.18 3.52 6.7.43 3-1.53 6.46.34 8.83.76 1 2 1.47 2.8 2.43 1.92 2.37.09 5.86.37 8.89.25 2.77 2.32 5.07 2.89 7.8s-.39 6.11 1.35 8.41c-1.77-2.79-5.65-3.34-8.91-2.8a20.19 20.19 0 0 0-13.27 8.59 26.23 26.23 0 0 0-1.24-11.76c-1.17-3.38-3.05-6.66-2.89-10.23.1-2.11.92-4.18.72-6.29-.31-3.3-3-5.81-5.32-8.14-2.82-2.81-5.57-6.15-5.85-10.13-.26-3.69 1.69-7.18 3.92-10.14a19.15 19.15 0 0 1 6.61-6c1.75-.86 7.05-4.46 8.21-4 2.49.94 4.38 9.35 4.93 11.63zM510.98 246.29a11.4 11.4 0 0 0-6.35 5.27 44 44 0 0 0-3.33 7.76 102.56 102.56 0 0 1-7.8 16.48c-2.34 4-5 7.84-6.26 12.25-1.13 3.86-1.21 8.06-3.07 11.62-.91 1.74-2.21 3.28-2.9 5.12-.9 2.38-.67 5-.42 7.56l.65 6.76a17.37 17.37 0 0 0 1.48 6.44c1.25 2.39 3.53 4 5.73 5.61l10.17 7.21a26.49 26.49 0 0 0 6.37 3.67c6.62 2.33 13.76-.88 20.72-1.76 4.8-.6 9.66-.09 14.47.43-.4-3.93-.27-8.09 1.63-11.55s7.69-8 11.52-7.06c-3.8-3.21-10.09-1.42-14.3-4.09-1.69-1.07-3.13-2.49-4.79-3.62-5.23-3.54-12.73-4.14-16.1-9.49a2.12 2.12 0 0 1-.4-1c-.06-.79.61-1.42 1.19-2 4.22-4 6.33-9.77 6.85-15.54s-.4-11.55-1.45-17.25c-.85-4.57-1.8-9.2-3.88-13.36s-5.37-7.91-9.73-9.46z",
    fill: "#4c4981"
  }), React.createElement("ellipse", {
    cx: 53.67,
    cy: 604.83,
    rx: 18.68,
    ry: 3.16,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M41.12 590.16s10.65-.33 13.86-2.61 16.39-5 17.19-1.35 16 18.23 4 18.33-27.97-1.89-31.19-3.82-3.86-10.55-3.86-10.55z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M76.37 603.26c-12 .09-27.95-1.88-31.16-3.83-2.44-1.49-3.41-6.82-3.73-9.28h-.36s.68 8.59 3.88 10.55 19.12 3.92 31.15 3.82c3.47 0 4.67-1.26 4.61-3.09-.49 1.11-1.78 1.8-4.39 1.83z",
    opacity: 0.2
  }), React.createElement("ellipse", {
    cx: 162,
    cy: 568.05,
    rx: 14.37,
    ry: 2.43,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M152.34 556.75s8.2-.25 10.67-2 12.61-3.86 13.22-1 12.32 14 3.07 14.11-21.51-1.44-24-2.94-2.96-8.17-2.96-8.17z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M179.46 566.83c-9.25.07-21.5-1.44-24-2.94-1.88-1.15-2.63-5.25-2.88-7.15h-.27s.52 6.62 3 8.12 14.72 3 24 2.94c2.67 0 3.59-1 3.54-2.38-.38.86-1.4 1.39-3.39 1.41z",
    opacity: 0.2
  }), React.createElement("ellipse", {
    cx: 96.79,
    cy: 721.64,
    rx: 34.31,
    ry: 5.8,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M73.74 694.69s19.57-.6 25.47-4.8 30.11-9.22 31.57-2.48 29.41 33.5 7.31 33.68-51.34-3.45-57.22-7-7.13-19.4-7.13-19.4z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M138.49 718.74c-22.1.18-51.34-3.44-57.23-7-4.48-2.73-6.27-12.53-6.86-17.05h-.66s1.24 15.78 7.13 19.37 35.13 7.2 57.22 7c6.38-.06 8.59-2.33 8.46-5.69-.88 2.06-3.31 3.33-8.06 3.37z",
    opacity: 0.2
  }), React.createElement("g", {
    opacity: 0.1,
    fill: primaryColor
  }, React.createElement("path", {
    d: "M787.51 258.46c2.2 6.84-3.8 30.65-3.8 30.65s-18.76-15.84-21-22.68a13.01 13.01 0 0 1 24.76-8zM786.9 171.7c-3.66 6.18-25.45 17.5-25.45 17.5s-.6-24.55 3-30.73a13.008 13.008 0 0 1 22.4 13.23zM782.34 480.57c-2.24 3.81-15.66 10.77-15.66 10.77s-.37-15.11 1.88-18.91a8.002 8.002 0 0 1 13.78 8.14zM928.4 442.7c-2.25 3.8-15.66 10.77-15.66 10.77s-.37-15.11 1.88-18.92a8.005 8.005 0 1 1 13.78 8.15zM771.43 382.01c-3.65 6.19-25.44 17.5-25.44 17.5s-.61-24.54 3-30.73a13.003 13.003 0 1 1 22.39 13.23z"
  })));
};
UndrawScooter.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawScooter;